import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { Autocomplete, Button, Stack, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import {
  createDupedLine,
  isBidLineUnawarded,
  clearBidAssignment,
  assignBidLine,
  assignBidGroup,
  assignDupedBidLine,
} from "../../util/bid/bidAward";

const AssignIneligibleAtOpenEmployeeDetailPanelContent = (props) => {
  const [assignedBidLineInput, setAssignedBidLineInput] = useState("");
  const [assignedBidLine, setAssignedBidLine] = useState("");

  useEffect(() => {
    let bidLineValue = "";
    if (props.employee.awardedLine) {
      bidLineValue = props.employee.awardedLine.toString().split(".")[0].toString();
    }
    setAssignedBidLine(bidLineValue);
    setAssignedBidLineInput(bidLineValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getValidBidLines = () => {
    let validBidLines = props.bidLines.filter((line) => line.ftpt === props.employee.ftpt && !line.isDupedLine);
    return validBidLines;
  };

  const handleBidLineAssignChange = (event, value, reason) => {
    if (reason === "clear") {
      const clearedBidLinesResult = clearBidAssignment(props.bidLines, props.bidGroup, props.employee.eid);
      props.setBidLines(clearedBidLinesResult.bidLines);
      props.setBidGroup(clearedBidLinesResult.bidGroup);
    }
    setAssignedBidLine(value);
  };

  const handleAssign = () => {
    if (assignedBidLine) {
      const bidLineNumber = parseFloat(assignedBidLine);
      if (isBidLineUnawarded(props.bidLines, bidLineNumber)) {
        const bidLineIdx = props.bidLines.findIndex((bidLine) => bidLine?.lineNumber === bidLineNumber);
        if (bidLineIdx !== -1) {
          const updatedBidLines = assignBidLine(props.bidLines, bidLineIdx, props.employee);
          props.setBidLines(updatedBidLines);
        }
        // Assign to bidGroup
        const selectedBidGroupIdx = props.bidGroup.findIndex((emp) => emp?.eid === props.employee.eid);
        if (selectedBidGroupIdx !== -1) {
          const updatedBidGroup = assignBidGroup(
            props.bidGroup,
            selectedBidGroupIdx,
            bidLineNumber,
            props.employee.awardType
          );
          props.setBidGroup(updatedBidGroup);
        }
      } else {
        // Clear existing assignments
        const clearedBidLinesResult = clearBidAssignment(props.bidLines, props.bidGroup, props.employee.eid);
        let dupedLineObj = null;

        // Assign to bidLines
        const selectedBidLineIdx = clearedBidLinesResult.bidLines.findIndex(
          (bidLine) => bidLine?.lineNumber.toString() === assignedBidLine
        );
        if (selectedBidLineIdx !== -1) {
          let copiedBidLines = clearedBidLinesResult.bidLines;
          dupedLineObj = createDupedLine(clearedBidLinesResult.bidLines, copiedBidLines[selectedBidLineIdx]);
          copiedBidLines = assignDupedBidLine(copiedBidLines, selectedBidLineIdx, dupedLineObj, props.employee);
          props.setBidLines(copiedBidLines);
        }

        // Assign to bidGroup
        const selectedBidGroupIdx = clearedBidLinesResult.bidGroup.findIndex((emp) => emp?.eid === props.employee.eid);
        if (selectedBidGroupIdx !== -1) {
          const updatedBidGroup = assignBidGroup(
            clearedBidLinesResult.bidGroup,
            selectedBidGroupIdx,
            dupedLineObj.dupedLine.lineNumber,
            props.employee.awardType
          );
          props.setBidGroup(updatedBidGroup);
        }
      }
    }
  };

  return (
    <Stack
      direction="row"
      sx={{
        display: "flex",
        paddingLeft: "1rem",
        paddingTop: "10px",
        paddingBottom: "10px",
        alignItems: "center",
        backgroundColor: "secondary.swaLightestBlue",
      }}
    >
      <Typography variant="subtitle1">Assign Bid Line</Typography>
      <Autocomplete
        id="bid-line-number"
        label="Bid Line #"
        options={getValidBidLines().map((line) => line.lineNumber.toString())}
        isOptionEqualToValue={(option, value) => option === value || value === ""}
        value={assignedBidLine}
        onChange={handleBidLineAssignChange}
        inputValue={assignedBidLineInput}
        onInputChange={(event, newInputValue) => {
          setAssignedBidLineInput(newInputValue);
        }}
        sx={{ marginLeft: "1rem", width: "160px" }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Bid Line #"
            size="small"
            sx={{ backgroundColor: "secondary.swaWhite", borderRadius: "5px" }}
          />
        )}
      />
      <Button
        variant="contained"
        color="primary"
        startIcon={<AssignmentIndIcon />}
        component="label"
        onClick={handleAssign}
        disabled={assignedBidLine === "" || assignedBidLine === null}
        sx={{ marginLeft: "1rem", height: "40px" }}
      >
        Assign
      </Button>
    </Stack>
  );
};

AssignIneligibleAtOpenEmployeeDetailPanelContent.propTypes = {
  employee: PropTypes.object.isRequired,
  bidLines: PropTypes.array.isRequired,
  setBidLines: PropTypes.func.isRequired,
  bidGroup: PropTypes.array.isRequired,
  setBidGroup: PropTypes.func.isRequired,
  ineligibleAtOpenList: PropTypes.array.isRequired,
};

export default AssignIneligibleAtOpenEmployeeDetailPanelContent;
